module.exports = __webpack_public_path__ + "c95534bafa234d37eb87ce588145e75b.png";